import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';


import { SERVER_PORT } from './server-port.token';
import { CustomHttpHeaders } from '@shared/data-access/enums';
import { REQUEST } from '@shared/data-access/constants';

@Injectable()
export class UniversalProxyInterceptor implements HttpInterceptor {
	constructor(@Optional() @Inject(REQUEST) protected request: any, @Optional() @Inject(SERVER_PORT) protected serverPort: string | number) {}

	/**
	 * @description
	 * Function that acts as an Interceptor for all Universal HTTP Requests.  It converts all
	 * relative URLs into absolute URLs
	 */
	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Defaulted cloned request, in case nothing is modified
		let clonedRequest = request.clone();

		// Cloned headers
		let headers = clonedRequest.headers;

		/*
		 * TODO: HACK UNTIL HTTPCLIENT OPTIONS ARE IMPLEMENTED -- SEE `https://github.com/angular/angular/issues/18155`
		 */
		// Check to see if we need to ignore the `X-PROXY-REQUEST` header
		if (request.headers.has(CustomHttpHeaders.X_PROXY_REQUEST) && typeof request.headers.get(CustomHttpHeaders.X_PROXY_REQUEST) === 'string') {
			// Modify the headers accordingly
			headers = headers
				.delete(CustomHttpHeaders.X_PROXY_REQUEST);

			// Check to see if the request should be proxied
			if (request.url.startsWith('http://') || request.url.startsWith('https://') || request.headers.get(CustomHttpHeaders.X_PROXY_REQUEST).toLowerCase() !== 'true') {
				// Send the newly created request with cloned headers
				return next.handle(clonedRequest.clone({
					headers
				}));
			}

			// Build the new absolute base URL
			let absoluteURL = `${ this.request.protocol }://localhost`;

			// Check to see if there is a server port
			if (typeof this.serverPort !== 'undefined' && this.serverPort !== null && this.serverPort !== '80' && this.serverPort !== 80) {
				absoluteURL += `:${ this.serverPort }`;
			}

			// Check to see if the request starts with a forward slash
			if (!request.url.startsWith('/')) {
				// Append the forward slash
				absoluteURL += '/';
			}

			// Append the relative URL to the absolute base URL
			absoluteURL += request.url;

			// Clone the Request with new headers
			clonedRequest = clonedRequest.clone({
				headers,
				url: absoluteURL
			});
		}

		// Send the newly created request
		return next.handle(clonedRequest);
	}
}
